import { useRef } from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const aboutRef = useRef(null);
  const programsRef = useRef(null);
  const instructorsRef = useRef(null);
  const enrollmentRef = useRef(null);
  const contactRef = useRef(null);
  const navigate = useNavigate();

  // Scroll handler function
  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const instructors = [
    {
      image: "/images/mo.jfif",
      name: "Meet Coach MO",
      title:
        "Helping swimmers build technique, confidence & a love for the water!",
      experience: [
        "10+ years of coaching experience",
        "7 years with top academies & schools across the UAE",
        "Certified by Swim England, STA (UK) & ASCA (Level 3)",
        "UAE Swimming Federation – Certified Coach",
      ],
      specialty: [
        "Teaching kids (3+ years)",
        "Adult training (beginners – advanced)",
        "Performance development & championship preparation",
      ],
      programs: [],
    },
    /*
    {
      image: "/images/mostafa.jpeg",
      name: "Meet Coach Mostafa",
      title: "Passionate about helping swimmers build skills, confidence & a love for swimming!",
      experience: [
        "Bachelor's Degree in Physical Education",
        "Former competitive swimmer",
        "Specialist in swimming instruction"
      ],
      specialty: [

      ],
      programs: [
        "Learn to Swim (kids 3+ years)",
        "Advanced technique & performance development",
        "Adult Learn to Swim (all levels)"
      ]
    },
    */
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-100">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-waves h-8 w-8 text-blue-600"
              >
                <path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
                <path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
                <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
              </svg>
              <h1 className="text-2xl font-bold text-gray-900">
                AQUA PRO SPORTS
              </h1>
            </div>
            <nav className="hidden md:flex space-x-8">
              <button
                onClick={() => scrollToSection(aboutRef)}
                className="text-gray-700 hover:text-blue-600 transition-colors"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection(programsRef)}
                className="text-gray-700 hover:text-blue-600 transition-colors"
              >
                Programs
              </button>
              <button
                onClick={() => scrollToSection(instructorsRef)}
                className="text-gray-700 hover:text-blue-600 transition-colors"
              >
                Instructors
              </button>
              <button
                onClick={() => scrollToSection(enrollmentRef)}
                className="text-gray-700 hover:text-blue-600 transition-colors"
              >
                Enrollment
              </button>
              <button
                onClick={() => scrollToSection(contactRef)}
                className="text-gray-700 hover:text-blue-600 transition-colors"
              >
                Contact
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Dive Into Your
            <span className="text-blue-600 block">Swimming Journey</span>
          </h2>
          <p className="text-xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
            Join thousands of swimmers who have learned to love the water with
            AQUA PRO SPORTS. From first splash to competitive excellence, we're
            here to guide every stroke of your journey.
          </p>
          <button
            onClick={() => scrollToSection(enrollmentRef)}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
          >
            Start Swimming Today
          </button>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              {
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-users h-8 w-8 text-blue-600"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                ),
                number: "2,500+",
                label: "Happy Swimmers",
              },
              {
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-trophy h-8 w-8 text-blue-600"
                  >
                    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
                    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
                    <path d="M4 22h16"></path>
                    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
                    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
                    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
                  </svg>
                ),
                number: "25+",
                label: "Certified Instructors",
              },
              {
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-8 w-8 text-blue-600"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                ),
                number: "98%",
                label: "Success Rate",
              },
              {
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-waves h-8 w-8 text-blue-600"
                  >
                    <path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
                    <path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
                    <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
                  </svg>
                ),
                number: "15+",
                label: "Years Experience",
              },
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="flex justify-center mb-4">{stat.icon}</div>
                <div className="text-3xl font-bold text-gray-900 mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section
        id="about"
        ref={aboutRef}
        className="py-20 bg-gradient-to-r from-blue-600 to-cyan-600 text-white"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-4xl font-bold mb-6">About AQUA PRO SPORTS</h3>
              <p className="text-xl mb-6 leading-relaxed">
                For over 15 years, AQUA PRO SPORTS has been the premier
                destination for swimming education in our community. We believe
                that swimming is not just a skill, but a life-changing
                experience that builds confidence, promotes health, and creates
                lasting memories.
              </p>
              <p className="text-lg mb-8 leading-relaxed opacity-90">
                Our state-of-the-art facilities, combined with our team of
                certified instructors, provide a safe and nurturing environment
                where swimmers of all ages and abilities can thrive. From
                toddlers taking their first splash to adults conquering their
                fears, we're committed to making every swimming journey
                successful and enjoyable.
              </p>
              <div className="grid sm:grid-cols-2 gap-6">
                {[
                  { icon: "shield", text: "Safety First Approach" },
                  { icon: "trophy", text: "Award-Winning Programs" },
                  { icon: "heart", text: "Personalized Attention" },
                  { icon: "clock", text: "Flexible Scheduling" },
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`lucide lucide-${item.icon} h-6 w-6 mr-3`}
                    >
                      {item.icon === "shield" && (
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      )}
                      {item.icon === "trophy" && (
                        <>
                          <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
                          <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
                          <path d="M4 22h16"></path>
                          <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
                          <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
                          <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
                        </>
                      )}
                      {item.icon === "heart" && (
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                      )}
                      {item.icon === "clock" && (
                        <>
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </>
                      )}
                    </svg>
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/863988/pexels-photo-863988.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop"
                alt="Swimming pool at AquaLife Academy"
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-white text-gray-900 p-6 rounded-xl shadow-lg">
                <div className="text-2xl font-bold text-blue-600">15+</div>
                <div className="text-sm">Years of Excellence</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section id="programs" ref={programsRef} className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">
              Our Swimming Programs
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive swimming programs designed to meet every swimmer's
              needs, from beginners to competitive athletes.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: "heart",
                color: "blue",
                title: "Learn to Swim",
                description:
                  "Perfect for beginners aged 3-12. Our gentle approach helps children overcome fear and build confidence in water.",
              },
              {
                icon: "trophy",
                color: "green",
                title: "Competitive Swimming",
                description:
                  "Advanced training for aspiring competitive swimmers with technique refinement and endurance building.",
              },
              {
                icon: "users",
                color: "purple",
                title: "Adult Swimming",
                description:
                  "Never too late to learn! Adult-focused classes in a comfortable, non-judgmental environment.",
              },
              {
                icon: "shield",
                color: "orange",
                title: "Water Safety",
                description:
                  "Essential water safety skills and survival techniques for swimmers of all levels.",
              },
            ].map((program, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow"
              >
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 bg-${program.color}-100 text-${program.color}-600`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`lucide lucide-${program.icon} h-6 w-6`}
                  >
                    {program.icon === "heart" && (
                      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                    )}
                    {program.icon === "trophy" && (
                      <>
                        <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
                        <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
                        <path d="M4 22h16"></path>
                        <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
                        <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
                        <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
                      </>
                    )}
                    {program.icon === "users" && (
                      <>
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </>
                    )}
                    {program.icon === "shield" && (
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    )}
                  </svg>
                </div>
                <h4 className="text-xl font-semibold mb-3 text-center">
                  {program.title}
                </h4>
                <p className="text-gray-600 text-center leading-relaxed">
                  {program.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instructors Section */}
      <section id="instructors" ref={instructorsRef} className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">
              Meet Our Expert Instructors
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our certified swimming instructors bring years of experience and
              passion for teaching to every lesson.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {instructors.map((instructor, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow"
              >
                <div className="text-center mb-6">
                  <img
                    src={instructor.image}
                    alt={instructor.name}
                    className="w-[250px] h-[300px] rounded-xl mx-auto mb-4 object-cover shadow-md"
                  />
                  <h4 className="text-xl font-semibold mb-2 text-gray-800">
                    {instructor.name}
                  </h4>
                  <p className="text-blue-600 font-medium mb-4">
                    {instructor.title}
                  </p>
                </div>

                <div className="space-y-4">
                  <div>
                    <h5 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                      Experience
                    </h5>
                    <div className="space-y-2">
                      {instructor.experience.map((exp, expIndex) => (
                        <div key={expIndex} className="flex items-center">
                          <span className="text-green-600 mr-2 mt-1">✔️</span>
                          <p className="text-gray-600 text-sm">{exp}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {instructor.specialty.length ? (
                    <div>
                      <h5 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                        Specialty
                      </h5>
                      <div className="space-y-2">
                        {instructor.specialty.map((spec, specIndex) => (
                          <div key={specIndex} className="flex items-center">
                            <span className="text-blue-600 mr-2 mt-1">•</span>
                            <p className="text-gray-600 text-sm">{spec}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {instructor.programs.length ? (
                    <div>
                      <h5 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                        Programs
                      </h5>
                      <div className="space-y-2">
                        {instructor.programs.map((spec, specIndex) => (
                          <div key={specIndex} className="flex items-center">
                            <span className="text-blue-600 mr-2 mt-1">•</span>
                            <p className="text-gray-600 text-sm">{spec}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Enrollment Section */}
      <section
        ref={enrollmentRef}
        id="enrollment"
        className="py-20 bg-gradient-to-br from-blue-50 to-cyan-100"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">
              Choose Your Swimming Experience
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Select the perfect swimming program that fits your schedule and
              learning preferences.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {[
              {
                icon: "home",
                color: "blue",
                title: "Private Pool Lessons",
                description:
                  "Personalized one-on-one swimming instruction in the comfort of your own pool. Our certified instructors bring all equipment and expertise to you.",
                price: "AED 150/session",
                buttonText: "Choose Private Lessons",
                link: "/private-lessons-plans",
              },
              {
                icon: "building2",
                color: "cyan",
                title: "Academy Classes",
                description:
                  "Join our state-of-the-art swimming facility with heated pools, small class sizes, and comprehensive swimming programs for all skill levels.",
                price: "AED 320/month",
                buttonText: "Choose Academy Classes",
                link: "/academy-classes-plans",
              },
            ].map((option, index) => (
              <div
                onClick={() => {
                  navigate(option.link);
                }}
                key={index}
                className={`group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer border-2 border-transparent hover:border-${option.color}-500`}
              >
                <div
                  className={`bg-${option.color}-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-${option.color}-500 transition-colors`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`lucide lucide-${option.icon} h-8 w-8 text-${option.color}-600 group-hover:text-white`}
                  >
                    {option.icon === "home" && (
                      <>
                        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </>
                    )}
                    {option.icon === "building2" && (
                      <>
                        <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                        <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                        <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                        <path d="M10 6h4"></path>
                        <path d="M10 10h4"></path>
                        <path d="M10 14h4"></path>
                        <path d="M10 18h4"></path>
                      </>
                    )}
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {option.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {option.description}
                </p>
                <div className={`bg-${option.color}-50 rounded-lg p-4 mb-6`}>
                  <div
                    className={`flex items-center justify-between text-sm text-${option.color}-800`}
                  >
                    <span>Starting from</span>
                    <span className="font-bold text-lg">{option.price}</span>
                  </div>
                </div>
                <button
                  className={`w-full bg-${option.color}-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-${option.color}-700 transition-colors group-hover:bg-${option.color}-700`}
                >
                  {option.buttonText}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section
        id="contact"
        ref={contactRef}
        className="py-20 bg-gray-900 text-white"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold mb-4">Get In Touch</h3>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Ready to start your swimming journey? Contact us today to learn
              more about our programs and schedule a visit.
            </p>
          </div>
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
              {[
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      ></path>
                    </svg>
                  ),
                  title: "Phone",
                  content: "+971 52 239 0957<br>",
                },
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      ></path>
                    </svg>
                  ),
                  title: "Email",
                  content: "info@aquaprosports.com",
                },
                {
                  icon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-clock h-8 w-8"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                  ),
                  title: "Hours",
                  content:
                    "Mon-Fri: 6:00 AM - 10:00 PM<br>Sat-Sun: 8:00 AM - 8:00 PM",
                },
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                  ),
                  title: "Location 1",
                  content:
                    "Dubai Investment Park<br><a href='https://maps.google.com?q=Durham%20School%20Dubai%20-%20Dubai&ftid=0x3e5f7392892c845d:0x90d4e9f76721094f&entry=gps&lucs=,94284472,94224825,94227247,94227248,94231188,94280568,47071704,47069508,94218641,94282134,94203019,47084304&g_st=ipc' target='_blank' className='text-blue-400 hover:text-blue-300 underline'>Go to Location</a>",
                },
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                  ),
                  title: "Location 2",
                  content:
                    "Al Wasl Club<br><a href='https://maps.app.goo.gl/UqM91x7ZjwG28ofz6?g_st=ipc' target='_blank' className='text-blue-400 hover:text-blue-300 underline'>Go to Location</a>",
                },
              ].map((contact, index) => (
                <div key={index} className="text-center">
                  <div className="bg-blue-600 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                    {contact.icon}
                  </div>
                  <h5 className="font-semibold mb-2">{contact.title}</h5>
                  <p
                    className="text-gray-300 text-sm"
                    dangerouslySetInnerHTML={{ __html: contact.content }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-waves h-8 w-8 text-blue-400"
                >
                  <path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
                  <path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
                  <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path>
                </svg>
                <h5 className="text-xl font-bold">AQUA PRO SPORTS</h5>
              </div>
              <p className="text-gray-400 mb-4 leading-relaxed">
                Making swimming accessible, enjoyable, and safe for everyone.
                Join our community of swimmers and discover the joy of aquatic
                excellence.
              </p>
              <div className="flex space-x-4">
                {[
                  {
                    icon: (
                      <svg
                        className="h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                      </svg>
                    ),
                    link: "https://www.facebook.com/share/1DaioSKLzd/?mibextid=wwXIfr",
                  },
                  {
                    icon: (
                      <svg
                        className="h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                      </svg>
                    ),
                    link: "https://www.instagram.com/aquapro.sports?igsh=emNncjBuMTlwNjNi&utm_source=qr",
                  },
                ].map((social, idx) => (
                  <a
                    key={idx}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors cursor-pointer"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h6 className="font-semibold mb-4">Quick Links</h6>
              <ul className="space-y-2 text-gray-400">
                <li onClick={() => scrollToSection(aboutRef)}>
                  <button className="hover:text-white transition-colors">
                    About Us
                  </button>
                </li>
                <li onClick={() => scrollToSection(programsRef)}>
                  <button className="hover:text-white transition-colors">
                    Programs
                  </button>
                </li>
                <li onClick={() => scrollToSection(instructorsRef)}>
                  <button className="hover:text-white transition-colors">
                    Instructors
                  </button>
                </li>
                <li onClick={() => scrollToSection(enrollmentRef)}>
                  <button className="hover:text-white transition-colors">
                    Enrollment
                  </button>
                </li>
              </ul>
            </div>
            <div>
              <h6 className="font-semibold mb-4">Programs</h6>
              <ul className="space-y-2 text-gray-400">
                {[
                  "Learn to Swim",
                  "Competitive Swimming",
                  "Adult Classes",
                  "Water Safety",
                ].map((program, idx) => (
                  <li key={idx}>
                    <a href="#" className="hover:text-white transition-colors">
                      {program}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>© 2025 AQUA PRO SPORTS. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
